import { useLanguage } from "@/lib/i18n";
import iconPdrnSalmon from "@/assets/icon-pdrn-salmon.png";
import iconScience from "@/assets/icon-science.png";
import iconGlassSkin from "@/assets/icon-glass-skin.png";

const TARGET_COUNTRIES = ['US', 'GB', 'AU', 'IL', 'HR', 'FI', 'FR', 'DE', 'NO', 'ES', 'AE'];

export function WhatIsPDRN() {
  const { t } = useLanguage();
  const detectedCountry = useLanguage(state => state.detectedCountry);

  const point1Key = detectedCountry && TARGET_COUNTRIES.includes(detectedCountry)
    ? `whatIsPDRN.origin.point1.${detectedCountry}`
    : 'whatIsPDRN.origin.point1';

  const cards = [
    {
      icon: iconPdrnSalmon,
      titleKey: 'whatIsPDRN.origin.title',
      subtitleKey: 'whatIsPDRN.origin.subtitle',
      points: [
        point1Key,
        'whatIsPDRN.origin.point2',
        'whatIsPDRN.origin.point3',
      ],
    },
    {
      icon: iconScience,
      titleKey: 'whatIsPDRN.howItWorks.title',
      subtitleKey: 'whatIsPDRN.howItWorks.subtitle',
      points: [
        'whatIsPDRN.howItWorks.point1',
        'whatIsPDRN.howItWorks.point2',
        'whatIsPDRN.howItWorks.point3',
      ],
    },
    {
      icon: iconGlassSkin,
      titleKey: 'whatIsPDRN.results.title',
      subtitleKey: 'whatIsPDRN.results.subtitle',
      points: [
        'whatIsPDRN.results.point1',
        'whatIsPDRN.results.point2',
        'whatIsPDRN.results.point3',
      ],
    },
  ];

  return (
    <section className="mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">
        {t('whatIsPDRN.title')}
      </h2>
      <p className="text-sm md:text-base text-muted-foreground text-center mb-5 md:mb-7 max-w-2xl mx-auto">
        {t('whatIsPDRN.subtitle')}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {cards.map((card, idx) => (
          <div
            key={idx}
            className="p-5 md:p-6 bg-white/70 rounded-2xl border border-white/80 shadow-sm flex flex-col"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 md:mb-4 rounded-2xl bg-gradient-to-br from-secondary to-pink-200 flex items-center justify-center p-2">
              <img src={card.icon} alt="" className="w-10 h-10 object-contain" aria-hidden="true" />
            </div>

            <h3 className="font-bold text-base md:text-lg text-center mb-1">
              {t(card.titleKey)}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground text-center mb-3 md:mb-4 italic">
              {t(card.subtitleKey)}
            </p>

            <ul className="space-y-2 flex-1">
              {card.points.map((pointKey, pIdx) => (
                <li key={pIdx} className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-1.5" />
                  <span className="text-xs md:text-sm text-foreground/80 leading-relaxed">
                    {t(pointKey)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
